import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.boundCloseOnBackdrop = this.closeOnBackdrop.bind(this)
  }

  disconnect() {
    if (this.hasDialogTarget) {
      this.dialogTarget.removeEventListener("click", this.boundCloseOnBackdrop)
    }
  }

  open(event) {
    event.preventDefault()
    this.dialogTarget.showModal()
    this.dialogTarget.addEventListener("click", this.boundCloseOnBackdrop)
  }

  close(event) {
    if (event) event.preventDefault()
    if (this.hasDialogTarget && this.dialogTarget.open) {
      this.dialogTarget.removeEventListener("click", this.boundCloseOnBackdrop)
      this.dialogTarget.close()
    }
  }

  closeOnBackdrop(event) {
    if (this.hasDialogTarget && event.target === this.dialogTarget) {
      this.close(event)
    }
  }
}
